import { render, staticRenderFns } from "./userHeader.vue?vue&type=template&id=318badc8&"
import script from "./userHeader.vue?vue&type=script&lang=js&"
export * from "./userHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports